import { Component, input, ViewChild } from '@angular/core';
import { PropertyListPage } from '../../../property/components/property-list/property-list.component';
import { MemberModel } from '../../../../core/models/data/member.model';
import { PropertyListViewLocations } from '../../../../core/enums/base.enums';
import { PropertyPermission } from '../../../../core/enums/permissions.enums';
import { AddPropertiesToMemberComponent } from '../add-properties-to-member/add-properties-to-member.component';
import { IfHasPermissionDirective } from '../../../../core/directives/if-has-permission/if-has-permission.directive';

@Component({
  selector: 'ms-member-properties',
  imports: [PropertyListPage, AddPropertiesToMemberComponent, IfHasPermissionDirective],
  templateUrl: './member-profile-properties.component.html'
})
export class MemberProfilePropertiesComponent {
  @ViewChild(PropertyListPage) propertyListRef!: PropertyListPage;

  public member = input<MemberModel | undefined>(undefined);

  public profilePageViewLocation = PropertyListViewLocations.MemberProfilePage;
  public PropertyPermission = PropertyPermission;

  public onMemberAddedToProperty(): void {
    this.propertyListRef?.loadProperties();
  }
}